import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isFromBuilderSelector, selectIsArchived, selectStats } from '../../selectors';
import { offerStatsPopupOpen } from '../../store/offer_stats_popup';
import { OfferStats } from './index';

export function OfferStatsContainer() {
  const dispatch = useDispatch();
  const isFromBuilder = useSelector(isFromBuilderSelector);
  const offerStats = useSelector(selectStats);
  const isOfferArchived = useSelector(selectIsArchived);

  const handleOfferStatsPopupOpen = React.useCallback(() => {
    dispatch(offerStatsPopupOpen());
  }, []);

  if (isOfferArchived) {
    return null;
  }

  return (
    <OfferStats isFromBuilder={isFromBuilder} offerStats={offerStats} offerStatsPopupOpen={handleOfferStatsPopupOpen} />
  );
}
